import { values, invert } from './object';

export const breakpoints = {
  xs: 0,
  s: 480,
  m: 768,
  l: 980,
};

export const getBreakpoint = (width) => {
  const vals = values(breakpoints).sort();
  const index = vals.findIndex(val => val > Math.max(width, 0));
  const target = index > -1 ? index - 1 : vals.length - 1;
  return invert(breakpoints)[vals[target]];
};



// WEBPACK FOOTER //
// ./src/universal/ui/utils/breakpoints.js